// Reducer para los Individuos
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    projectName: "",
    text: "",
    places: [],
    timeLines: [
        {
            timeLineID: 0,
            timeLineName: 'Inicio',
            tlPlace: '',
            relationshipIDCount: 0,
            priorityArr1: 0,
            priorityArr2: 0,
            priorityArr3: 0,
            nodes: [
                {
                    id: 'M0',
                    label: 'Inicio',
                    shape: 'dot',
                    color: '#6e8ecf',
                    x: 100,
                    y: -200,
                    status: '0',
                    shapeProperties: {
                      borderDashes: false
                    },
                    hidden: false,
                    type: 'momento'
                  }
            ],
            edges: []
        }
    ]
}

export const projectArrReducer = createSlice({
    name: 'project',
    initialState,
    reducers: {
        agregarNombre: (state, action) => {
            state.projectName = action.payload
        },
        agregarTexto: (state, action) => {
            state.text = action.payload
        },
        cargarProyecto: (state, action) => {
            state.projectName = action.payload.project.projectName
            state.text = action.payload.project.text
            state.timeLines = action.payload.project.timeLines
        },
        limpiarProyecto: () => initialState,
        agregarIndividuoALineaTemporal: (state, action) => {
            let lenArr = state.timeLines[action.payload.timeLineID].nodes.length;

            let priorityArr = action.payload.priority

            switch (priorityArr) {
                case '1':
                    {
                        state.timeLines[action.payload.timeLineID].priorityArr1++
                    }
                    break;
                case '2':
                    {
                        state.timeLines[action.payload.timeLineID].priorityArr2++
                    }
                    break;
                case '3':
                    {
                        state.timeLines[action.payload.timeLineID].priorityArr3++
                    }
                    break;
            }


            // hidden: [ false: no aparece en el VIS, true: Aparece en el VIS ]
            state.timeLines[action.payload.timeLineID].nodes = [...state.timeLines[action.payload.timeLineID].nodes,
            {
                id: (lenArr), label: action.payload.label, shape: action.payload.shape, color: action.payload.color, priority: action.payload.priority,
                title: "", x: action.payload.x, y: action.payload.y, status: action.payload.status, shapeProperties: action.payload.shapeProperties, hidden: false, type: "individual"
            }]
        },
        agregarObjetoALineaTemporal: (state, action) => {
            let lenArr = state.timeLines[action.payload.timeLineID].nodes.length;
            // hidden: [ false: no aparece en el VIS, true: Aparece en el VIS ]
            state.timeLines[action.payload.timeLineID].relationshipIDCount++
            let relationshipIDCount = state.timeLines[action.payload.timeLineID].relationshipIDCount
            // Obj Owner individal
            const { idFromNode } = action.payload
            // let idFNode = idFromNode

            //Aumenta id de los nodes
            state.timeLines[action.payload.timeLineID].nodes = state.timeLines[action.payload.timeLineID].nodes.map(obj => {
                // eslint-disable-next-line
                if (obj.id >= idFromNode) { return { ...obj, id: obj.id + 1 }; } else { return obj; }
            });

            // Agrega Objeto
            state.timeLines[action.payload.timeLineID].nodes.splice(idFromNode, 0, {
                id: (idFromNode), label: action.payload.label, font: { color: action.payload.fcolor }, shape: action.payload.shape, color: action.payload.color,
                x: action.payload.x, y: action.payload.y, status: action.payload.status, shapeProperties: action.payload.shapeProperties, hidden: false, type: 'object'
            })


            //Aumenta id de los nodes
            state.timeLines[action.payload.timeLineID].nodes = state.timeLines[action.payload.timeLineID].nodes.map(obj => {
                // eslint-disable-next-line
                if (obj.id >= idFromNode) { return { ...obj, id: obj.id + 1 }; } else { return obj; }
            });

            //Agrega campo relacional
            state.timeLines[action.payload.timeLineID].nodes.splice(idFromNode, 0, {
                id: (idFromNode),
                shape: "circle",
                //color: "hsla(0, 0%, 100%, 0)",
                borderWidth: 2,
                color: {
                    border: '#000000',
                    background: 'hsla(0, 0%, 100%, 0)',
                },
                "x": state.timeLines[action.payload.timeLineID].nodes[(idFromNode)].x - 15,
                "y": state.timeLines[action.payload.timeLineID].nodes[(idFromNode)].y - 15,
                widthConstraint: 80,
                hidden: false,
                type: "diadaField"
            })

            // Modifica id de los edges
            state.timeLines[action.payload.timeLineID].edges = state.timeLines[action.payload.timeLineID].edges.map((obj) => {
                if (obj.from == idFromNode && obj.to < idFromNode) {
                    return { ...obj, from: obj.from + 2 }
                } else {
                    if (obj.from >= idFromNode) {
                        return {
                            // eslint-disable-next-line
                            ...obj, from: obj.from + 2, to: obj.to + 2
                        }
                    } else {
                        if (obj.relType == 'ind_ind' && (obj.from == idFromNode || obj.to == idFromNode)) {
                            return { ...obj, to: obj.to + 2 }
                        } else {
                            return obj
                        }
                    }
                }
            })

            // // Crea relación entre el objeto y la persona
            state.timeLines[action.payload.timeLineID].edges = [...state.timeLines[action.payload.timeLineID].edges,
            {
                id: (relationshipIDCount), from: idFromNode + 1, to: idFromNode + 2, relType: 'ind_obj'
            }
            ]
        },
        updateIndividual: (state, action) => {
            const nodes = state.timeLines[action.payload.timeLineID].nodes

            state.timeLines[action.payload.timeLineID].nodes[action.payload.nodeID] = {
                ...nodes[action.payload.nodeID],
                color: action.payload.color, status: action.payload.status,
                shapeProperties: { borderDashes: action.payload.shapeProperties }, hidden: action.payload.hidden
            }
        },
        updateObject: (state, action) => {
            const nodes = state.timeLines[action.payload.timeLineID].nodes
            if (nodes[action.payload.nodeID].type != 'diadaField') {

                state.timeLines[action.payload.timeLineID].nodes[action.payload.nodeID] = {
                    ...nodes[action.payload.nodeID],
                    color: '#FF0000',
                    hidden: action.payload.hidden
                }

            } else {

                state.timeLines[action.payload.timeLineID].nodes[action.payload.nodeID] = {
                    ...nodes[action.payload.nodeID],
                    borderWidth: 2,
                    color: {
                        border: '#000000',
                        background: 'hsla(0, 0%, 100%, 0)',
                    },
                    hidden: action.payload.hidden
                }
            }
        },
        agregarRelacion: (state, action) => {
            state.timeLines[action.payload.timeLineID].relationshipIDCount++
            let relationshipIDCount = state.timeLines[action.payload.timeLineID].relationshipIDCount
            // value es el grosor de la relacion, entre 1 y 8
            // from, to reciben id del nodo
            state.timeLines[action.payload.timeLineID].edges = [...state.timeLines[action.payload.timeLineID].edges, { id: (relationshipIDCount), from: action.payload.from, to: action.payload.to, width: action.payload.width, arrows: action.payload.arrows, dashes: action.payload.dashes, label: action.payload.label, font: action.payload.font, relType: 'ind_ind' }]
        },
        updateTextFragmentIndividual(state, action) {
            const { id, newTitle } = action.payload;
            const nodes = state.timeLines[action.payload.timeLineID].nodes
            state.timeLines[action.payload.timeLineID].nodes = nodes.map(obj => {
                // eslint-disable-next-line
                if (obj.id === id) { return { ...obj, title: obj.title + "\n\n" + newTitle }; } else { return obj; }
            });
        },
        agregarLineaTemporal: (state, action) => {

            let lenArr = state.timeLines.length;
            const nodes = state.timeLines[action.payload.timeLineID].nodes;
            let nodesIndiduals = [];
            nodes.forEach(element => {
                if (element.type == "individual" || element.type == "diadaField" || element.type == "object") {
                    nodesIndiduals.push(element)
                }
            });
            const edges = state.timeLines[action.payload.timeLineID].edges;
            let newEdges = []

            edges.forEach(element => {
                if (element.relType == 'ind_obj') {
                    newEdges.push({ id: element.id, from: element.from, to: element.to, relType: element.relType })
                }
            })

            state.timeLines = [...state.timeLines, {
                timeLineID: lenArr,
                timeLineName: action.payload.timeLineName,
                tlPlace: "",
                date: action.payload.date,
                relationshipIDCount: state.timeLines[action.payload.timeLineID].relationshipIDCount,
                priorityArr1: state.timeLines[action.payload.timeLineID].priorityArr1,
                priorityArr2: state.timeLines[action.payload.timeLineID].priorityArr2,
                priorityArr3: state.timeLines[action.payload.timeLineID].priorityArr3,
                nodes: nodesIndiduals,
                edges: newEdges
            }]
        },
        agregarNodoDeLineaTemporal: (state, action) => {
            let lenArr = state.timeLines.length - 1;
            state.timeLines[lenArr].nodes = [{
                id: 'M' + lenArr, label: action.payload.timeLineName, shape: action.payload.shape, color: action.payload.color,
                x: action.payload.x, y: action.payload.y, status: action.payload.status,
                shapeProperties: action.payload.shapeProperties, hidden: false, type: 'momento' //action.payload.type
            }, ...state.timeLines[lenArr].nodes]
        },
        agregarNodoDeCampoRelacional: (state, action) => {
            const TL = action.payload.timeLineID
            const nodes = state.timeLines[TL].nodes
            let locationObj = {}
            // const nodes = state.timeLines[TL].nodes
            nodes.forEach((item) => {
                if (item.type == 'location') {
                    return locationObj = { id: nodes.indexOf(item), "containsPlace": true }
                }
            })

            if (!locationObj.containsPlace) {
                state.timeLines[TL].nodes = [...state.timeLines[TL].nodes,
                {
                    id: 'U' + TL, label: action.payload.label, shape: 'ellipse', color: action.payload.color,
                    x: action.payload.x, y: action.payload.y, status: action.payload.status,
                    shapeProperties: action.payload.shapeProperties, hidden: false, type: 'location' //action.payload.type
                }]
            } else {
                state.timeLines[TL].nodes[locationObj.id] = {
                    id: 'U' + TL, label: action.payload.label, shape: 'ellipse', color: action.payload.color,
                    x: action.payload.x, y: action.payload.y, status: action.payload.status,
                    shapeProperties: action.payload.shapeProperties, hidden: false, type: 'location' //action.payload.type
                }
            }
        },
        deleteRelationship: (state, action) => {
            let edges = state.timeLines[action.payload.timeLineID].edges
            let indexID = action.payload.id
            let f;
            let found = edges.some(function (item, index) { f = index; return item.id == indexID; });
            if (!found) {
                return false;
            }
            edges.splice(f, 1);
        },
        addTimeLinePlace: (state, action) => {
            const tlPlaceIN = action.payload.tlPlace
            if (!(state.places).includes(tlPlaceIN)) {
                state.places.push(tlPlaceIN)
            }
            // Adds the place to the TL
            state.timeLines[action.payload.timeLineID].tlPlace = tlPlaceIN
        }
    },
})

// Action creators are generated for each case reducer function

export const {
    agregarIndividuoALineaTemporal,
    agregarObjetoALineaTemporal,
    updateTextFragmentIndividual,
    agregarRelacion,
    agregarLineaTemporal,
    agregarNodoDeLineaTemporal,
    agregarNodoDeCampoRelacional,
    updateIndividual,
    updateObject,
    agregarNombre,
    agregarTexto,
    deleteRelationship,
    cargarProyecto,
    limpiarProyecto,
    addTimeLinePlace} = projectArrReducer.actions

export default projectArrReducer.reducer